// extracted by mini-css-extract-plugin
export default {"coloredLine":"ColoredLine_coloredLine__-bLS1","color":"ColoredLine_color__Dxxzg"};